import { message, Select } from "antd"
import { useEffect, useState } from "react"
import "./index.scss";
import { postRequest } from "../../../../services/requestService";
export default props => {
    const {savedJob} = props;
    const [value, setValue] = useState('interested')
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        setValue(savedJob.applicationStatus)
    }, [savedJob])
    
    const onSelect = async (newVal) => {
        setLoading(true)
        
        setTimeout(async () => {
            await postRequest('saved-job/update', {savedJobId: savedJob._id, applicationStatus: newVal })
            setValue(newVal)
            setLoading(false)
            message.success('Application status changed')
        }, 1000)
        
        
    }
    return (
        <Select style={{minWidth: 130}} className="status-picker" value={value} loading={loading} options={[
            {label: 'Interested', value: 'interested' },
            {label: 'Applied', value: 'applied' },
            {label: 'Offer', value: 'offer' },
            {label: 'Rejected', value: 'rejected' },
            {label: 'Archived', value: 'archived' },
        ]} onChange={onSelect} />
    )
}